// Resources of jobs handled by the background-job-manager (see unify-service background-job-runner/handleJobRun.js).
// IoT Data Hub exports need N1, twin exports do not, so they are listed in different background job tabs.
export const IOT_HUB_EXPORT_RESOURCES = ['influx-measurements'];
export const TWIN_EXPORT_RESOURCES = ['digital-twin-rule-executions', 'twin-state-values-pdf'];

export const IOT_HUB_EXPORTS_TAB = 'file-export';
export const TWIN_EXPORTS_TAB = 'csv-bulk-export';

export const backgroundJobsTabForResource = (resource) =>
  IOT_HUB_EXPORT_RESOURCES.includes(resource) ? IOT_HUB_EXPORTS_TAB : TWIN_EXPORTS_TAB;

// background-job states mapped to the background-runner states the export table understands
const JOB_STATE_TO_RUNNER_STATE = {
  queued: 'created',
  running: 'in progress',
  done: 'done',
  failed: 'done',
  canceled: 'canceled',
};

// Maps a background job (GET /background-jobs) to the background runner row shape of the export table,
// so status, download hint and download work the same for both.
export const backgroundJobToExportRow = (job) => ({
  rowKey: `job-${job.id}`,
  isBackgroundJob: true,
  id: job.id,
  title: job.name,
  jobState: job.state,
  state: JOB_STATE_TO_RUNNER_STATE[job.state] || job.state,
  resource: job.resource,
  createdAt: job.createdAt,
  tasks: { errors: 0 },
  executions: {
    ...(job.state === 'failed' ? { success: false, error: (job.error && job.error.msg) || null } : {}),
    result: { data: { fileId: (job.result && job.result.fileId) || null } },
  },
});

export const backgroundRunnerToExportRow = (runner) => ({ ...runner, rowKey: `runner-${runner.id}` });

// Merges the first `offset + limit` rows of both (already createdAt sorted) lists and returns the requested page.
export const mergeExportRows = (runners, jobs, { offset, limit, sortDesc = true }) => {
  const direction = sortDesc ? -1 : 1;
  // tie-break equal creation dates by row key, so the order (and with it the pages) is stable across requests
  const rows = [...runners.map(backgroundRunnerToExportRow), ...jobs.map(backgroundJobToExportRow)].sort(
    (a, b) =>
      direction * (new Date(a.createdAt) - new Date(b.createdAt)) ||
      direction * a.rowKey.localeCompare(b.rowKey, undefined, { numeric: true })
  );
  return rows.slice(offset, offset + limit);
};
